<template>
  <div>
    <loading v-if="load" full="true" style="top: 32%"/>
    <div v-show="!load">
      <h6 class="mt-1 mb-2 text-center font-weight-bold">{{ dados ? 'Modelos de mensagems' : 'Nova Mensagem' }}</h6>
      <div class="mb-2" v-if="!dados">
        <div class="mb-1">
          <label class="small font-weight-bold mb-0">Telefone</label>
          <the-mask :mask="['(##) ####-####', '(##) #####-####']" class="form-control" id="phoneInput" placeholder="(##) #####-###" v-model="contact.wa_id"/>
        </div>
        <div class="mb-2" v-if="!dados">
          <label class="small font-weight-bold mb-0">Nome de contato</label>
          <input type="text" class="form-control" id="nameInput" placeholder="Ex: Maria" v-model="contact.name"/>
        </div>
      </div>
      <div v-if="templates.length">
        <a class="d-flex justify-content-between align-items-center text-dark text-decoration-none px-2 py-3 border-top" href="javascript:"
           v-for="(t, index) in templates" @click="selTemplate(t.id)">
          <div>{{ t.content || `Modelo ${index + 1}`}}</div>
          <i class="fa fa-angle-right text-muted"></i>
        </a>
      </div>
      <div class="border-top pt-3 text-center" v-else>
        <div class="alert alert-info">
          Você ainda não tem modelos de mensagems para novas conversas.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueFuse from "vue-fuse";
import Loading from "@/components/loading";

export default {
  name: "ModalTemplate",
  props: ['dados', 'session'],
  components: {Loading, VueFuse},
  data() {
    return {
      load: true,
      templates: [],
      contact: { wa_id: '', name: '' }
    }
  },

  methods: {
    getTemplates() {
      this.load = true;
      this.$http.get('templates')
        .then(response => {
          this.load = false;
          this.templates = (response.data || []).filter(t => t.type == 2);
          this.$nextTick(() => {
            this.$helpers.focusElement('phoneInput');
          })

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    selTemplate(template_id) {
      if (this.load) {
        return;
      }

      if (!this.dados) {
        if (this.contact.wa_id.length < 10) {
          this.$swal('Por favor informe um número de telefone válido').then(() => {
            this.$helpers.focusElement('phoneInput');
          });

          return;
        }

        if (this.contact.name.length < 3) {
          this.$swal('Por favor informe um nome de contato válido').then(() => {
            this.$helpers.focusElement('nameInput');
          });

          return;
        }
      }

      const dados = { template_id, contact_id: this.dados ? this.dados.id : null, session: this.session, contact: this.contact }
      this.load = true;

      this.$http.post('messages/template', dados)
        .then(res => {
          this.load = false;
          this.$emit('close');

          if (res.data && res.data.success) {
            this.$emit('atualizar');
            this.$swal('Mensagem enviada com sucesso, aguarde a resposta deste contato para conversar com ele.');

          } else {
            this.$swal('Não foi possível enviar esta mensagem, verifique se possui créditos suficientes para o envio!');
          }

        }, res => {
          this.load = false;
          this.$swal('Não foi possível enviar esta mensagem, verifique se possui créditos suficientes para o envio!');
        });
    }
  },

  mounted() {
    this.getTemplates();
  }
}
</script>

<style scoped>
</style>
